import moment from 'moment';
import { StringSchema } from 'yup';

/* eslint func-names: 0 */

export function beforeToday(this: StringSchema, format: string, message?: string): StringSchema {
  return this.test({
    message,
    test(value) {
      const date = moment(value, format);

      if (!date.isValid()) {
        return this.createError({ message });
      }

      if (moment().isAfter(date)) {
        return false;
      }

      return true;
    },
  });
}

export function isLegalAge(this: StringSchema, format: string, message?: string): StringSchema {
  return this.test({
    message,
    test(value) {
      const date = moment(value, format, true);

      if (!date.isValid()) {
        return this.createError({ message });
      }

      if (moment().diff(date, 'years') < 18) {
        return false;
      }

      return true;
    },
  });
}
